/* eslint-disable indent */
import React from "react";
import { NOTA_INTERESES_FACTORING } from "../constants";
import styles from "../stylesERv2.module.scss";

export const EBITDAResultadoTable = ({
  modoCombinado,
  monthsToShow,
  formatCurrency,
  porcentajeSobreFacturacion,
  valoresMensuales,
  ingresosHardwareMensual,
  ingresosGestionContenidosMensual,
  ingresosBTLMensual,
  camposCostosFijos,
  getCostoFijoValor,
  rrhhMensualConBeneficios,
  totalCostosMes,
  margenFinal,
  costosFijosYTD,
  sumarCostosFijosMes,
  valoresMensualesComisionAgencia,
  valoresMensualesComisiones,
  valoresMensualesComisionComercial,
  conceptosManuales,
  getValueForMonth,
  compraHardwareMensual,
  instalacionMensual,
  materialesMensual,
  otrosCostosMensual,
  getCostoGestionValue,
  comisionEdificiosBTLMensual,
  otrosCostosBTLMensual,
  ebitCollapsed,
  setEbitCollapsed,
  depreciacionMensual,
  amortizacionMensual,
  meses,
  resultadoCollapsed,
  setResultadoCollapsed,
  interesesER,
  vInteresesLocal,
  interesesWindowedMensualUSD,
  onDetalleIntereses,
  verChileYPeru,
  verEnDolares,
  pais,
  moneda,
  dolarMensual,
  dolarMensualPeru,
  dolarFallback,
  verUltimos12Meses,
  ebitdaMensualWindowed,
  facturacionMensualWindowed,
  costosVariablesMensualWindowed,
  costosFijosMensualWindowed,
  ebitMensual,
  resultadoMensual,
  ebitWindowedMensual,
  resultadoWindowedMensual,
  ebitWindowedMensualUSD,
  resultadoWindowedMensualUSD,
  filas,
  filasCombinado,
  vEbitdaUSD,
  vEbitUSD,
  vBeneficioNetoUSD,
}) => (
  <>
    {/* === EBITDA === */}
    <tr className={styles.ebitdaRow}>
      <td className={styles.conceptCellMargen}>EBITDA</td>
      {Array(12)
        .fill(0)
        .map((_, i) => {
          if (i >= monthsToShow) return <td key={i}>-</td>;
          // FASE E2b: modo combinado (Sumar Perú) lee de `filasCombinado` (fuente única,
          // Chile+Perú fila por fila) — nunca una resta aparte con los arrays combinados sueltos.
          if (modoCombinado) {
            const ebitda = filasCombinado.EBITDA.usd[i] || 0;
            return (
              <td key={i} className="text-end">
                <div className={ebitda < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitda, i, null, true)}</div>
              </td>
            );
          }
          // FASE 3 PASO 3 (criterio 1), punto 4 — Chile + "Ver en US$": `vEbitdaUSD`/
          // `filas.EBITDA.usd` ya son bottom-up (Σ de las filas hoja de A-D ya convertidas,
          // nunca una reconversión de EBITDA en pesos) — Perú sigue con el camino de siempre
          // (10.265/10.267), sin cambio.
          if (pais === "Chile" && verEnDolares) {
            const ebitdaUsd = (verUltimos12Meses ? vEbitdaUSD : filas.EBITDA.usd)?.[i] || 0;
            return (
              <td key={i} className="text-end">
                <div className={ebitdaUsd < 0 ? styles.marginNegative : ""}>
                  {formatCurrency(ebitdaUsd, i, null, true)}
                </div>
              </td>
            );
          }
          // Modo ventana: usar array pre-computado
          if (verUltimos12Meses) {
            const ebitda = ebitdaMensualWindowed[i] || 0;
            return (
              <td key={i} className="text-end">
                <div className={ebitda < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitda, i)}</div>
              </td>
            );
          }
          // Modo normal — FASE E2a: lee de `filas` (fuente única), nunca recalcula.
          const ebitda = filas.EBITDA.local[i] || 0;
          return (
            <td key={i} className="text-end">
              <div className={ebitda < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitda, i)}</div>
            </td>
          );
        })}
      <td className={styles.totalCell}>
        {(() => {
          if (modoCombinado) {
            const totalFact = filasCombinado.FACTURACIÓN.usd.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const ebitdaComb = filasCombinado.EBITDA.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
            const pct = totalFact > 0 ? ((ebitdaComb / totalFact) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitdaComb < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitdaComb, null, null, true)} | {pct}
              </div>
            );
          }
          // FASE 3 PASO 3 (criterio 1), punto 4 — Chile + "Ver en US$": monto bottom-up; el %
          // se sigue midiendo en pesos (invariante de moneda, mismo criterio que Software DS/
          // Contribución más arriba en este mismo encargo) — nunca se reconvierte EBITDA.
          if (pais === "Chile" && verEnDolares) {
            const ebitdaYTDPeso = (verUltimos12Meses ? ebitdaMensualWindowed : filas.EBITDA.local)
              .slice(0, monthsToShow)
              .reduce((a, b) => a + (b || 0), 0);
            const ebitdaYTDUsd = (verUltimos12Meses ? vEbitdaUSD : filas.EBITDA.usd)
              .slice(0, monthsToShow)
              .reduce((a, b) => a + (b || 0), 0);
            return (
              <div className={ebitdaYTDPeso < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitdaYTDUsd, null, null, true)} | {porcentajeSobreFacturacion(ebitdaYTDPeso)}
              </div>
            );
          }
          // Modo ventana: usar arrays pre-computados
          if (verUltimos12Meses) {
            const ebitdaYTD = ebitdaMensualWindowed.reduce((a, b) => a + b, 0);
            const factYTD = facturacionMensualWindowed.reduce((a, b) => a + b, 0);
            const pct = factYTD > 0 ? ((ebitdaYTD / factYTD) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitdaYTD < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitdaYTD, null, ebitdaMensualWindowed)} | {pct}
              </div>
            );
          }
          // Modo normal — FASE E2a: lee de `filas` (fuente única).
          const ebitdaYTD = filas.EBITDA.local.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
          return (
            <div className={ebitdaYTD < 0 ? styles.marginNegative : ""}>
              {formatCurrency(ebitdaYTD, null, filas.EBITDA.local)} | {porcentajeSobreFacturacion(ebitdaYTD)}
            </div>
          );
        })()}
      </td>
    </tr>
    {/* Depreciación y Amortización (colapsables desde EBIT) */}
    {!ebitCollapsed && (
      <>
        <tr>
          <td className={styles.conceptCell}>Depreciación</td>
          {meses.map((_, i) => (
            <td key={i} className="text-end">
              {i < monthsToShow
                ? modoCombinado
                  ? formatCurrency(filasCombinado.Depreciación.usd[i], null, null, true)
                  : // LTM (E2b, sin tocar acá): esta fila nunca tuvo rama propia de ventana — el
                    // prop `depreciacionMensual` YA llega windowed desde `index.js` (`vDepreciacion`)
                    // cuando `verUltimos12Meses` está prendido. Modo normal (E2a): lee de `filas`.
                    formatCurrency(verUltimos12Meses ? depreciacionMensual[i] : filas["Depreciación"].local[i], i)
                : "-"}
            </td>
          ))}
          <td className={styles.totalCell}>
            {modoCombinado
              ? formatCurrency(
                  filasCombinado.Depreciación.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
                  null,
                  null,
                  true
                )
              : verUltimos12Meses
                ? formatCurrency(
                    depreciacionMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                    null,
                    depreciacionMensual
                  )
                : formatCurrency(
                    filas["Depreciación"].local.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                    null,
                    filas["Depreciación"].local
                  )}
          </td>
        </tr>
        <tr>
          <td className={styles.conceptCell}>Amortización</td>
          {meses.map((_, i) => (
            <td key={i} className="text-end">
              {i < monthsToShow
                ? modoCombinado
                  ? formatCurrency(filasCombinado.Amortización.usd[i], null, null, true)
                  : // LTM (E2b, sin tocar acá): mismo caso que Depreciación arriba.
                    formatCurrency(verUltimos12Meses ? amortizacionMensual[i] : filas["Amortización"].local[i], i)
                : "-"}
            </td>
          ))}
          <td className={styles.totalCell}>
            {modoCombinado
              ? formatCurrency(
                  filasCombinado.Amortización.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
                  null,
                  null,
                  true
                )
              : verUltimos12Meses
                ? formatCurrency(
                    amortizacionMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                    null,
                    amortizacionMensual
                  )
                : formatCurrency(
                    filas["Amortización"].local.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                    null,
                    filas["Amortización"].local
                  )}
          </td>
        </tr>
      </>
    )}

    {/* === EBIT (clickeable) === */}
    <tr
      className={styles.ebitRow}
      onClick={() => setEbitCollapsed(!ebitCollapsed)}
      style={{ cursor: "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCellMargen}>Beneficio Operativo | EBIT {ebitCollapsed ? ">" : ""}</td>
      {meses.map((_, i) => {
        if (i >= monthsToShow) {
          return (
            <td key={i} className="text-end">
              -
            </td>
          );
        }
        // FASE E2b: modo combinado lee de `filasCombinado` (fuente única).
        if (modoCombinado) {
          const ebit = filasCombinado["Beneficio Operativo | EBIT"].usd[i] || 0;
          return (
            <td key={i} className="text-end">
              <div className={ebit < 0 ? styles.marginNegative : ""}>{formatCurrency(ebit, null, null, true)}</div>
            </td>
          );
        }
        // Modo ventana: usar array pre-computado (PASO 3.6a). PASO 3.6b, H5: en US$ se usa el
        // array YA convertido con el TC de la ventana (`ebitWindowedMensualUSD`) — nunca
        // `formatCurrency(valor, i)`, que convertiría con `dolarMensual[i]` (TC del índice crudo,
        // no el del mes/año que ESTE slot ventaneado realmente representa).
        if (verUltimos12Meses) {
          // FASE 3 PASO 3 (criterio 1), punto 4 — Chile: `vEbitUSD` ya es bottom-up y
          // ventaneado (EBITDA nuevo, D&A criterio de hoy sin cambio). Perú sigue con el
          // `ebitWindowedMensualUSD` de siempre (10.265/10.267).
          if (pais === "Chile" && verEnDolares) {
            const ebitUsd = vEbitUSD?.[i] || 0;
            return (
              <td key={i} className="text-end">
                <div className={ebitUsd < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitUsd, i, null, true)}</div>
              </td>
            );
          }
          const ebit = (verEnDolares ? ebitWindowedMensualUSD : ebitWindowedMensual)[i] || 0;
          return (
            <td key={i} className="text-end">
              <div className={ebit < 0 ? styles.marginNegative : ""}>{formatCurrency(ebit, i, null, verEnDolares)}</div>
            </td>
          );
        }
        // FASE 3 PASO 3 (criterio 1), punto 4 — Chile + "Ver en US$": `filas[...].usd` ya es
        // bottom-up (EBITDA nuevo − Depreciación/Amortización, criterio de hoy sin cambio,
        // 4f) — nunca una reconversión genérica del peso. Perú no cambia (10.265/10.267).
        if (pais === "Chile" && verEnDolares) {
          const ebitUsd = filas["Beneficio Operativo | EBIT"].usd[i] || 0;
          return (
            <td key={i} className="text-end">
              <div className={ebitUsd < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitUsd, i, null, true)}</div>
            </td>
          );
        }
        // Modo normal — FASE E2a: lee de `filas` (fuente única).
        const ebit = filas["Beneficio Operativo | EBIT"].local[i] || 0;
        return (
          <td key={i} className="text-end">
            <div className={ebit < 0 ? styles.marginNegative : ""}>{formatCurrency(ebit, i)}</div>
          </td>
        );
      })}
      <td className={styles.totalCell}>
        {(() => {
          if (modoCombinado) {
            const totalFact = filasCombinado.FACTURACIÓN.usd.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const ebitComb = filasCombinado["Beneficio Operativo | EBIT"].usd
              .slice(0, monthsToShow)
              .reduce((a, b) => a + (b || 0), 0);
            const pct = totalFact > 0 ? ((ebitComb / totalFact) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitComb < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitComb, null, null, true)} | {pct}
              </div>
            );
          }
          // Modo ventana: usar arrays pre-computados. PASO 3.6b, H5: en US$, YTD = suma de los
          // 12 slots YA convertidos con el TC de la ventana (`ebitWindowedMensualUSD`).
          if (verUltimos12Meses) {
            if (pais === "Chile" && verEnDolares) {
              const ebitYTDPeso = ebitWindowedMensual.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
              const ebitYTDUsd = (vEbitUSD || Array(12).fill(0))
                .slice(0, monthsToShow)
                .reduce((a, b) => a + (b || 0), 0);
              const factYTD = facturacionMensualWindowed.reduce((a, b) => a + b, 0);
              const pct = factYTD > 0 ? ((ebitYTDPeso / factYTD) * 100).toFixed(1) + "%" : "0%";
              return (
                <div className={ebitYTDPeso < 0 ? styles.marginNegative : ""}>
                  {formatCurrency(ebitYTDUsd, null, null, true)} | {pct}
                </div>
              );
            }
            const ebitSerie = verEnDolares ? ebitWindowedMensualUSD : ebitWindowedMensual;
            const ebitYTDW = ebitSerie.reduce((a, b) => a + (b || 0), 0);
            const factYTD = facturacionMensualWindowed.reduce((a, b) => a + b, 0);
            const pct = factYTD > 0 ? ((ebitYTDW / factYTD) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitYTDW < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitYTDW, null, null, verEnDolares)} | {pct}
              </div>
            );
          }
          // FASE 3 PASO 3 (criterio 1), punto 4 — Chile + "Ver en US$": monto bottom-up; el %
          // se sigue midiendo en pesos (mismo criterio que EBITDA más arriba).
          if (pais === "Chile" && verEnDolares) {
            const ebitArrPeso = filas["Beneficio Operativo | EBIT"].local;
            const ebitYTDPeso = ebitArrPeso.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
            const ebitYTDUsd = filas["Beneficio Operativo | EBIT"].usd
              .slice(0, monthsToShow)
              .reduce((a, b) => a + (b || 0), 0);
            return (
              <div className={ebitYTDPeso < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitYTDUsd, null, null, true)} | {porcentajeSobreFacturacion(ebitYTDPeso)}
              </div>
            );
          }
          // Modo normal — FASE E2a: lee de `filas` (fuente única).
          const ebitArr = filas["Beneficio Operativo | EBIT"].local;
          const ebitYTD = ebitArr.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
          return (
            <div className={ebitYTD < 0 ? styles.marginNegative : ""}>
              {formatCurrency(ebitYTD, null, ebitArr)} | {porcentajeSobreFacturacion(ebitYTD)}
            </div>
          );
        })()}
      </td>
    </tr>

    {/* Intereses e Impuestos (colapsables desde Resultado) */}
    {!resultadoCollapsed && (
      <>
        <tr>
          <td className={styles.conceptCell}>
            <span title={NOTA_INTERESES_FACTORING} style={{ cursor: "help" }}>
              Intereses
            </span>
          </td>
          {meses.map((_, i) => {
            if (i >= monthsToShow) {
              return (
                <td key={i} className="text-end">
                  -
                </td>
              );
            }
            // La celda del mes abre el detalle de intereses (mismo patrón que las líneas de
            // costo): el valor NO cambia, solo se envuelve en un div clickeable.
            const celdaProps = {
              onClick: () => onDetalleIntereses?.abrir(i, meses[i]),
              style: { cursor: "pointer" },
            };
            // En modo región: FASE E2b, lee de `filasCombinado` (fuente única).
            if (verChileYPeru) {
              const formatted = Math.round(filasCombinado.Intereses.usd[i] || 0).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  <div {...celdaProps}>US$ {formatted}</div>
                </td>
              );
            }
            // Modo ventana (LTM) — FASE E2c: nunca tuvo rama propia, mostraba el valor SIN
            // ventana (modo normal) aunque el TOTAL de Intereses ya restaba el valor correcto
            // por dentro. US$ precomputado con `vTC` (H5), nunca `formatCurrency(valor, i)` con
            // el TC crudo del índice.
            if (verUltimos12Meses) {
              if (verEnDolares) {
                const formatted = Math.round(interesesWindowedMensualUSD[i] || 0).toLocaleString("es-CL");
                return (
                  <td key={i} className="text-end">
                    <div {...celdaProps}>US$ {formatted}</div>
                  </td>
                );
              }
              const formatted = Math.round(vInteresesLocal[i] || 0).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  <div {...celdaProps}>
                    {moneda(pais)}
                    {formatted}
                  </div>
                </td>
              );
            }
            // País local — FASE E2a: lee de `filas` (fuente única).
            if (verEnDolares) {
              const formatted = Math.round(filas.Intereses.usd[i] || 0).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  <div {...celdaProps}>US$ {formatted}</div>
                </td>
              );
            }
            // Moneda local
            const interesesLocal = filas.Intereses.local[i] || 0;
            const formatted = Math.round(interesesLocal).toLocaleString("es-CL");
            return (
              <td key={i} className="text-end">
                <div {...celdaProps}>
                  {moneda(pais)}
                  {formatted}
                </div>
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {(() => {
              // En modo región: FASE E2b, lee de `filasCombinado` (fuente única).
              if (verChileYPeru) {
                const totalUSD = filasCombinado.Intereses.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // Modo ventana (LTM) — FASE E2c.
              if (verUltimos12Meses) {
                if (verEnDolares) {
                  const totalUSD = interesesWindowedMensualUSD.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                  return `US$ ${totalUSD.toLocaleString("es-CL")}`;
                }
                const totalLocal = vInteresesLocal.slice(0, monthsToShow).reduce((sum, v) => sum + (v || 0), 0);
                return `${moneda(pais)}${Math.round(totalLocal).toLocaleString("es-CL")}`;
              }
              // País local — FASE E2a: lee de `filas` (fuente única).
              if (verEnDolares) {
                const totalUSD = filas.Intereses.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // Moneda local
              const totalLocal = filas.Intereses.local.slice(0, monthsToShow).reduce((sum, v) => sum + (v || 0), 0);
              return `${moneda(pais)}${Math.round(totalLocal).toLocaleString("es-CL")}`;
            })()}
          </td>
        </tr>
        <tr>
          <td className={styles.conceptCell}>Impuestos</td>
          {meses.map((_, i) => {
            if (i >= monthsToShow) {
              return (
                <td key={i} className="text-end">
                  -
                </td>
              );
            }
            // En modo región: FASE E2b, lee de `filasCombinado` (fuente única).
            if (verChileYPeru) {
              const formatted = Math.round(filasCombinado.Impuestos.usd[i] || 0).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  US$ {formatted}
                </td>
              );
            }
            // País local — FASE E2a: lee de `filas` (fuente única).
            if (verEnDolares) {
              return (
                <td key={i} className="text-end">
                  US$ {Math.round(filas.Impuestos.usd[i] || 0).toLocaleString("es-CL")}
                </td>
              );
            }
            // Moneda local
            const impuestosLocal = filas.Impuestos.local[i] || 0;
            return (
              <td key={i} className="text-end">
                {moneda(pais)}
                {Math.round(impuestosLocal).toLocaleString("es-CL")}
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {(() => {
              // En modo región: FASE E2b, lee de `filasCombinado` (fuente única).
              if (verChileYPeru) {
                const totalUSD = filasCombinado.Impuestos.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // País local — FASE E2a: lee de `filas` (fuente única).
              if (verEnDolares) {
                const totalUSD = filas.Impuestos.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // Moneda local
              const totalLocal = filas.Impuestos.local.slice(0, monthsToShow).reduce((sum, v) => sum + (v || 0), 0);
              return `${moneda(pais)}${Math.round(totalLocal).toLocaleString("es-CL")}`;
            })()}
          </td>
        </tr>
      </>
    )}

    {/* === RESULTADO (clickeable) === */}
    <tr
      className={styles.resultadoRow}
      onClick={() => setResultadoCollapsed(!resultadoCollapsed)}
      style={{ cursor: "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCellMargen}>Beneficio Neto {resultadoCollapsed ? ">" : ""}</td>
      {meses.map((_, i) => {
        if (i >= monthsToShow) {
          return (
            <td key={i} className="text-end">
              -
            </td>
          );
        }
        // FASE E2b: modo combinado lee de `filasCombinado` (fuente única).
        if (modoCombinado) {
          const resultado = filasCombinado["Beneficio Neto"].usd[i] || 0;
          return (
            <td key={i} className="text-end">
              <div className={resultado < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultado, null, null, true)}
              </div>
            </td>
          );
        }
        // Modo ventana: usar arrays pre-computados (PASO 3.6a). PASO 3.6b, H5: en US$ se usa
        // `resultadoWindowedMensualUSD` (convertido con el TC de la ventana), nunca
        // `formatCurrency(valor, i)` con el TC crudo del índice.
        if (verUltimos12Meses) {
          // FASE 3 PASO 3 (criterio 1), punto 4 — Chile: `vBeneficioNetoUSD` ya es bottom-up y
          // ventaneado. Perú sigue con `resultadoWindowedMensualUSD` (10.265/10.267).
          if (pais === "Chile" && verEnDolares) {
            const resultadoUsd = vBeneficioNetoUSD?.[i] || 0;
            return (
              <td key={i} className="text-end">
                <div className={resultadoUsd < 0 ? styles.marginNegative : ""}>
                  {formatCurrency(resultadoUsd, i, null, true)}
                </div>
              </td>
            );
          }
          const resultado = (verEnDolares ? resultadoWindowedMensualUSD : resultadoWindowedMensual)[i] || 0;
          return (
            <td key={i} className="text-end">
              <div className={resultado < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultado, i, null, verEnDolares)}
              </div>
            </td>
          );
        }
        // FASE 3 PASO 3 (criterio 1), punto 4 — Chile + "Ver en US$": bottom-up ya construido
        // en `filas` (fuente única).
        if (pais === "Chile" && verEnDolares) {
          const resultadoUsd = filas["Beneficio Neto"].usd[i] || 0;
          return (
            <td key={i} className="text-end">
              <div className={resultadoUsd < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultadoUsd, i, null, true)}
              </div>
            </td>
          );
        }
        // Modo normal — FASE E2a: lee de `filas` (fuente única).
        const resultado = filas["Beneficio Neto"].local[i] || 0;
        return (
          <td key={i} className="text-end">
            <div className={resultado < 0 ? styles.marginNegative : ""}>{formatCurrency(resultado, i)}</div>
          </td>
        );
      })}
      <td className={styles.totalCell}>
        {(() => {
          if (modoCombinado) {
            const totalFact = filasCombinado.FACTURACIÓN.usd.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const resultadoComb = filasCombinado["Beneficio Neto"].usd
              .slice(0, monthsToShow)
              .reduce((a, b) => a + (b || 0), 0);
            const pct = totalFact > 0 ? ((resultadoComb / totalFact) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={resultadoComb < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultadoComb, null, null, true)} | {pct}
              </div>
            );
          }
          // Modo ventana: usar arrays pre-computados. PASO 3.6b, H5: en US$, YTD = suma de los
          // 12 slots YA convertidos con el TC de la ventana (`resultadoWindowedMensualUSD`).
          if (verUltimos12Meses) {
            if (pais === "Chile" && verEnDolares) {
              const resultadoYTDPeso = resultadoWindowedMensual
                .slice(0, monthsToShow)
                .reduce((a, b) => a + (b || 0), 0);
              const resultadoYTDUsd = (vBeneficioNetoUSD || Array(12).fill(0))
                .slice(0, monthsToShow)
                .reduce((a, b) => a + (b || 0), 0);
              const factYTD = facturacionMensualWindowed.reduce((a, b) => a + b, 0);
              const pct = factYTD > 0 ? ((resultadoYTDPeso / factYTD) * 100).toFixed(1) + "%" : "0%";
              return (
                <div className={resultadoYTDPeso < 0 ? styles.marginNegative : ""}>
                  {formatCurrency(resultadoYTDUsd, null, null, true)} | {pct}
                </div>
              );
            }
            const resultadoSerie = verEnDolares ? resultadoWindowedMensualUSD : resultadoWindowedMensual;
            const resultadoYTDW = resultadoSerie.reduce((a, b) => a + (b || 0), 0);
            const factYTD = facturacionMensualWindowed.reduce((a, b) => a + b, 0);
            const pct = factYTD > 0 ? ((resultadoYTDW / factYTD) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={resultadoYTDW < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultadoYTDW, null, null, verEnDolares)} | {pct}
              </div>
            );
          }
          // FASE 3 PASO 3 (criterio 1), punto 4 — Chile + "Ver en US$": bottom-up ya construido.
          if (pais === "Chile" && verEnDolares) {
            const resultadoArrPeso = filas["Beneficio Neto"].local;
            const resultadoYTDPeso = resultadoArrPeso.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
            const resultadoYTDUsd = filas["Beneficio Neto"].usd
              .slice(0, monthsToShow)
              .reduce((a, b) => a + (b || 0), 0);
            return (
              <div className={resultadoYTDPeso < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultadoYTDUsd, null, null, true)} | {porcentajeSobreFacturacion(resultadoYTDPeso)}
              </div>
            );
          }
          // Modo normal — FASE E2a: lee de `filas` (fuente única).
          const resultadoArr = filas["Beneficio Neto"].local;
          const resultadoYTD = resultadoArr.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
          return (
            <div className={resultadoYTD < 0 ? styles.marginNegative : ""}>
              {formatCurrency(resultadoYTD, null, resultadoArr)} | {porcentajeSobreFacturacion(resultadoYTD)}
            </div>
          );
        })()}
      </td>
    </tr>
  </>
);
